import { frontendURL } from '../../../helper/URLHelper';
import KanbanView from './pages/KanbanView.vue';

// :attributeKey identifica QUAL quadro Kanban abrir — cada atributo
// personalizado de conversa do tipo lista vira um quadro próprio, com
// as etapas sendo os itens da lista desse atributo.
const kanbanRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban/:attributeKey'),
      name: 'kanban_view',
      meta: {
        permissions: [
          'administrator',
          'agent',
          'conversation_manage',
          'conversation_unassigned_manage',
          'conversation_participating_manage',
        ],
      },
      component: KanbanView,
    },
  ],
};

export default kanbanRoutes;
